// src/features/hmi-simulator/hooks/useHeartbeat.ts
import { useEffect, useRef } from 'react';
import { HEARTBEAT_INTERVAL, HEARTBEAT_INITIAL_DELAY } from '../constants/config';

export const useHeartbeat = (
  isProvisioned: boolean,
  controllerConfig: any,
  api: any,
  setIsOnline: (value: boolean) => void
) => {
  const heartbeatInterval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!isProvisioned || !controllerConfig) return;

    const sendHeartbeat = async () => {
      try {
        // Manejar ambos formatos: snake_case y camelCase
        const lockerControllers = controllerConfig.lockerControllers || 
                                  controllerConfig.locker_controllers || 
                                  [];
        
        console.log('Controller Config:', controllerConfig);
        console.log('Locker Controllers:', lockerControllers);
        
        // 1. Enviar heartbeat general del HMI con información de todos los controladores
        const heartbeatData = {
          HMIControllerStatus: {
            IpAddress: controllerConfig.hmiControllerIp || 
                      controllerConfig.hmi_controller_ip || 
                      "192.168.100.21",
            TcpPort: controllerConfig.tcpPort || 
                    controllerConfig.tcp_port || 
                    8080,
            IsConnected: true,
            LastSuccessfulCommunication: new Date().toISOString()
          },
          LockerControllerStatuses: lockerControllers.map((controller: any) => ({
            IpAddress: controller.ipAddress || controller.ip_address,
            TcpPort: controller.tcpPort || controller.tcp_port,
            IsConnected: true,
            LastSuccessfulCommunication: new Date().toISOString(),
            ControllerId: controller.id
          })),
          Timestamp: new Date().toISOString()
        };
        
        console.log('Heartbeat data being sent:', heartbeatData);
        
        await api.sendHeartbeat(heartbeatData);
        
        // 2. COMENTADO: Los heartbeats individuales están fallando por falta de autenticación
        // El endpoint report-controller-heartbeat espera el HMIId en el contexto
        // pero el middleware no lo está estableciendo correctamente.
        // Por ahora, el heartbeat principal con el array debería ser suficiente.
        
        /* 
        if (lockerControllers && lockerControllers.length > 0) {
          for (const controller of lockerControllers) {
            try {
              const ipAddress = controller.ipAddress || controller.ip_address;
              const tcpPort = controller.tcpPort || controller.tcp_port;
              
              await api.reportControllerHeartbeat(ipAddress, tcpPort);
              console.log(`Controller heartbeat sent for ${ipAddress}:${tcpPort}`);
            } catch (error) {
              console.error(`Failed to send controller heartbeat for controller:`, controller, error);
            }
          }
        }
        */
        
        setIsOnline(true);
      } catch (error) {
        console.error('Heartbeat failed:', error);
        setIsOnline(false);
      }
    };

    // Enviar primer heartbeat después de un pequeño delay
    const timeoutId = setTimeout(() => {
      sendHeartbeat();
      // Configurar el intervalo para envíos posteriores
      heartbeatInterval.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
    }, HEARTBEAT_INITIAL_DELAY);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      if (heartbeatInterval.current) {
        clearInterval(heartbeatInterval.current);
      }
    };
  }, [isProvisioned, controllerConfig, api, setIsOnline]);
};